// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "cxfcomponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "cxfcomponents/Navbars/DashboardNavbar";

function BaseLayout({ stickyNavbar=false, children, avatar }) {
  return (
    <>
      <div
        style={{
        padding: "8px",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        backgroundColor: "var(--main-bg-color)"
      }}
      >
        <DashboardNavbar avatar={avatar} />
      </div>
      <DashboardLayout>
        <SoftBox mt={stickyNavbar ? 3 : -3} mb={3}>
          {children}
        </SoftBox>
      </DashboardLayout>
    </>
  );
}

// Typechecking props for BaseLayout
BaseLayout.propTypes = {
  stickyNavbar: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default BaseLayout;
